import { addIndex, isEmpty, map } from "ramda"

import React from "react"
import { makeStyles } from "@cirrus/ui-kit"

import Portal from "@cirrus/legacy/features/core/shared/components/portals/index.jsx"
import Notification from "./notification.jsx"

const useStyles = makeStyles({
  container: {
    position: "fixed",
    top: "80px",
    left: "0",
    right: "0",
    zIndex: "9000",
    margin: "auto",
    width: "536px",
  },
})

export const NotificationComponent = ({ notifications, onHideNotification }) => {
  const classes = useStyles()

  if (isEmpty(notifications)) return null

  return (
    <Portal>
      <div className={classes.container}>
        {addIndex(map)(
          (notification, index) => (
            <Notification
              key={`${notification.id}-${index}`}
              message={notification.message}
              htmlEnabled={notification.htmlEnabled}
              type={notification.type}
              isHideEnabled={notification.isHideEnabled}
              onHide={() => onHideNotification(notification.id)}
            />
          ),
          notifications,
        )}
      </div>
    </Portal>
  )
}